import type { VehicleSearchFilters } from "@dealer-center/inventory-pages-gvm-interface";

const gvmStoragePrefix = "inventory-pages-gvm-";
const weekInMillis = 7 * 24 * 60 * 60 * 1000;

export function displayWarningModal(): boolean {
  const warning = gvmStoragePrefix + "warningModal";
  const data: string | null = localStorage.getItem(warning);

  if (data === null) {
    localStorage.setItem(warning, JSON.stringify(new Date().getTime()));
    return true;
  } else if (new Date().getTime() - Number(data) > weekInMillis) {
    localStorage.setItem(warning, JSON.stringify(new Date().getTime()));
    return true;
  }
  return false;
}

const liveQueryFiltersId = gvmStoragePrefix + "live-query";

export function getLiveQueryFilters(): VehicleSearchFilters | null {
  const data = localStorage.getItem(liveQueryFiltersId);
  return data ? JSON.parse(data) : null;
}

export function saveLiveQueryFilters(filters: VehicleSearchFilters) {
  localStorage.setItem(liveQueryFiltersId, JSON.stringify(filters));
}
